module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, undefined) {

	var XFormData = window.xFormData = require('../../scripts/xformdata');

	var methods = {
		/**
		 * Set _fakeResponse object property
		 * @param {Number} httpStatus 200, 404, etc
		 * @param {Object} resHeaders response headers
		 * @param {String} resBody    response body
		 */
		setFakeResponse: function (httpStatus, resHeaders, resBody) {
			if (typeof sinon === 'undefined') {
				return false;
			}

			this._originalTransport = this._getTransport();

			this._transport = null;

			sinon.useFakeXMLHttpRequest();

			this._getTransport();

			if (arguments.length === 1) {
				if (fox.isArray(arguments[0])) {
					this._fakeResponse = arguments[0];
				}
			} else {
				httpStatus = httpStatus || 200;
				resHeaders = resHeaders || JSON.stringify({'Content-Type': 'application/json'});

				this._fakeResponse = [httpStatus, resHeaders, resBody];
			}
		},

		configure: function(options) {
			this.registerOptions('', {
				domain: '',
				address: '/api.php', //TODO add to global config
				httpMethod: 'get',
				sendTimezone: false,
				basePath: ''
			}, true, 'defaut api settings');

			this._transport = null;
			this.isService = true;
			this.registerOptions('', options || {}, false, 'configure');
			this.staticParams = {};
			this._complete = false;
			this._startTime = null;
			this._working = null;
			this._fillWomPatterns();
		},

		setStaticParams: function(params) {
			this.staticParams = params;
		},

		isActive: function() {
			return true;
		},

		method: function(method) {
			if (method) {
				this.setOption('method', method);
				return this;
			}

			return this.getOption('method');
		},

		domain: function(domain) {
			if (domain) {
				this.setOption('domain', domain);
				return this;
			}

			return this.getOption('domain');
		},

		alias: function(alias) {
			if (alias) {
				this._alias = alias;
				return this;
			}

			return this._alias;
		},

		section: function(section) {
			if (section) {
				this._section = section;
				return this;
			}

			return this._section;
		},

		action: function(action) {
			if (action) {
				this._action = action;
				return this;
			}

			return this._action;
		},

		setUnloadMessage: function() {
			//console.log('set unload message')
			if (fox.site.activeApiPosts > 1) {
				//console.log('DID NOT SET! its count is ' + fox.site.activeApiPosts)
				return;
			}

			//console.log('SET! now its count is ' + fox.site.activeApiPosts)
			fox.site.oldonbeforeunload = window.onbeforeunload;
			window.onbeforeunload = function() {
				return 'Some uploads are in progress, please wait until them over';
			};
		},

		unsetUnloadMessage: function() {
			//console.log('remove unload message')
			if (fox.site.activeApiPosts > 0) {
				//console.log('DID NOT REMOVE! its count is ' + fox.site.activeApiPosts)
				return;
			}

			//console.log('REMOVE! its count is ' + fox.site.activeApiPosts)
			window.onbeforeunload = fox.site.oldonbeforeunload;
		},

		getTimezone: function() {
			return -1 * (new Date()).getTimezoneOffset() / 60;
		},

		prepare: function (params) {},

		prepareAddressAndParams: function(data, jsonizeToParamsArg) {
			var postBody,i,
				address = this.requireOption('address'),
				params = {
					'_method': this.requireOption('method')
				};

			if (address === '/api.php') {
				var secure = this.getOption('secure');
				if (secure) {
					address = '/sapi/' + secure[0] + '/' + secure[1] + '/' + params._method;
				} else {
					address = '/api/' + params._method;
				}
			}

			if (this.getOption('basePath')) {
				address = this.getOption('basePath') + address;
			}

			if (this.requireOption('sendTimezone')) {
				params.tz = this.getTimezone();
			}

			for (i in this.staticParams) {
				if (this.staticParams.hasOwnProperty(i)) {
					params[i] = this.staticParams[i];
				}
			}

			var staticParams = this.getOption('staticParams');
			for (i in staticParams) {
				if (staticParams.hasOwnProperty(i)) {
					params[i] = staticParams[i];
				}
			}

			if (this.getOption('paramsToPath')) {
				address = address + '/' + data.join('/');
			} else {
				for (i in data) {
					if (data.hasOwnProperty(i)) {
						params[i] = data[i];
					}
				}
			}

			if (jsonizeToParamsArg) {
				params.params = JSON.stringify(params);
			}

			var staticApi = 0;
			var cacheChannel = this.getOption('cacheChannel');
			if (cacheChannel) {
				var url = this._wom.getRoot().getOption('cacheChannels.' + cacheChannel);
				if (url) {
					address = url + '/' + this.requireOption('method');
					delete params._method;
					staticApi = 1;
				}
			}

			if (!staticApi && this.requireOption('httpMethod').toLowerCase() === 'post') {
				postBody = fox.toQueryString(params, !!this.getOption('encodePost'));
			} else {
				address = address + '?' + fox.toQueryString(params, true);
			}

			if (this.getOption('domain') && address.indexOf('http') !== 0) {
				address = this.getOption('domain') + address;
			}

			return {
				address: address,
				params: params,
				postBody: postBody,
				staticApi: staticApi
			};
		},

		send: function(data, jsonizeToParamsArg) {
			this._startTime = new Date().getTime();

			if (this.isService && typeof jsonizeToParamsArg === 'undefined') {
				jsonizeToParamsArg = true; // change to false in future
			}

			this.dispatchEvent('prepare', {params: data});
			this.hookWrapper('prepare', {params: data});

			if (this.getOption('useFormData')) {
				return this._sendFormData(data);
			}

			var anp = this.prepareAddressAndParams(data, jsonizeToParamsArg);
			var socketWidget = this._wom.getRoot().Socket;

			if (this.getOption('useSocket') && !anp.staticApi && socketWidget) {
				if (socketWidget.isReady()) {
					this.clearPullTimer();

					this.waitEvent(socketWidget, 'socketDisconnected', fox.bind(function () {
						this.send(data, jsonizeToParamsArg);
					}, this));

					return socketWidget.sendApiRequest(this, anp.params);
				} else {
					if (fox.isNumeric(this.getOption('pullTimeout'))) {
						this.clearPullTimer();
					}

					if (!this.pullTimer && fox.isNumeric(this.getOption('pullTimeout'))) {
						this.waitEvent(socketWidget, 'socketDisconnected', fox.bind(function () {// nobody knows why this code placed here. copied it to socket part ^^^
							this.send(data, jsonizeToParamsArg);
						}, this));

						this.pullTimer = setInterval(fox.bind(function () {
							if (this.isActive()) {
								this.send(data, jsonizeToParamsArg);
							}

							this.waitEvent(socketWidget, 'socketReady', fox.bind(function () {
								this.clearPullTimer();
							}, this), {alwaysActive: true});
						}, this), this.getOption('pullTimeout'));
					}
				}
			}

			if (this._working) {
				this.dispatchEvent('stopWorking');
			}
			this.dispatchEvent('startWorking');
			this._working = true;
			


			var t = this.openConnection(anp.address);

			if (!anp.staticApi) {
				t.setRequestHeader('Access-Control-Allow-Credentials', 'true');
				t.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
			}

			if (this._originalTransport && this._fakeResponse.length === 3) {
				return t.respond(this._fakeResponse[0], this._fakeResponse[1], this._fakeResponse[2]);
			}

			t.send(anp.postBody);
		},

		openConnection: function (address) {
			var t = this._getTransport();

			t.open(this.requireOption('httpMethod'), address, true);

			return t;
		},

		psend: function () {
			var
				handlerParams,
				defParams = {prefix: 'promiseHandler'}
			;

			if (arguments[2] !== undefined) {
				handlerParams = arguments[2];

				defParams = fox.merge(defParams, handlerParams);
			}

			var promise = this.wait('@this', ['success', 'failure', 'error'], defParams, fox.bind(function (resolve, reject, t, e, p) {
				this.getEm().handle(t, e, function (_params, _performer, _event) {
					var data = {
						params: _params,
						performer: _performer,
						event: _event
					};

					if (_event === 'success') {
						resolve(data);
					} else {
						reject(data);
					}
				}, p);
			}, this));

			this.send.apply(this, arguments);

			return promise;
		},

		abort: function () {
			if (this._transport && this._transport.abort) {
				this._transport.abort();
			}
		},

		clearPullTimer: function() {
			if (this.pullTimer) {
				clearInterval(this.pullTimer);
				this.pullTimer = null;
			}
		},

		__getXhr: function() {
			if (window.XMLHttpRequest) {
				return new XMLHttpRequest;
			}

			if (window.ActiveXObject) {
				return new ActiveXObject("Msxml2.XMLHTTP");
			}

			return new ActiveXObject("Microsoft.XMLHTTP");
		},

		__bindRsc: function(xhr) {
			xhr.onreadystatechange = fox.bind(function () {
				if (xhr.readyState == 4) {
					this._onComplete.apply(this, arguments);
				}
			}, this);
		},

		__bindXhrEvents: function(xhr) {
			var events = ['loadstart', 'progress', 'abort', 'error', 'timeout', 'loadend'];

			if (this._originalTransport) {
				events = ['progress', 'abort', 'error', 'load'];
			}

			fox.each(events, function(event) {
				fox.dom.on(event, xhr.upload, fox.bind(function(e) {
					if (event == 'loadstart') {
						this.inProgress = true;
						this.progress = 0;
						this.dispatchEvent(event);
						return;
					}

					if (event == 'progress') {
						var current = Math.floor(e.loaded / e.total * 100);

						if (this.progress < current) {
							this.progress = current;
							this.dispatchEvent(event, {percent: this.progress, loaded: e.loaded, total: e.total});
						}

						return;
					}

					if (this.getOption('beforeUnloadMessage')) {
						window.onbeforeunload = this.oldonbeforeunload;
					}

					this.inProgress = false;
					this.dispatchEvent(event);
				}, this));
			}, this);
		},

		_getTransport: function() {
			if (!this._transport) {
				this._transport = this.__getXhr();
				this.__bindRsc(this._transport);

				if (this._transport.upload) {
					this.__bindXhrEvents(this._transport);
				}
			}

			return this._transport;
		},

		_onComplete: function() {
			this._working = false;
			this.dispatchEvent('stopWorking');

			var response = {transport: this._transport};
			this.lastResponse = response;

			if (this._transport.status >= 300) {
				response.error = 'httpStatus';
				this.dispatchEvent('error', response);
			} else {
				try {
					response.answer = JSON.parse(this._transport.responseText);
					this.dispatchResponseEvent(this.lastResponse);
				} catch (e) {
					response.error = 'jsonParse';
					this.dispatchEvent('error', response);
				}
			}

			if (this.getOption('httpMethod').toLowerCase() == 'post') {
				fox.site.activeApiPosts--;
				this.unsetUnloadMessage();
			}

			if (this._originalTransport) {
				window.XMLHttpRequest.restore();

				this._transport = this._originalTransport;
				this._originalTransport = null;
			}
		},

		dispatchResponseEvent: function(response) {
			if (!response.answer.status) {
				this.dispatchEvent('failure', response);
			} else {
				this.dispatchEvent('success', response);
				this.dispatchEvent('ready', response.answer.response);
			}
		}
	};

	fox.registerWidget('Api', fox.mixin({
		configure: function(options) {
			this.registerOptions('', {
				domain: '',
				address: '/api.php', //TODO add to global config
				httpMethod: 'get',
				jsonizeToParamsArg: false,
				sendTimezone: false,
				pullTimeout: false,
				inboxSocketEvent: false, //listen this event from Socket for socket INBOX
				inboxSocketCallback: false, //inbox socket custom callback or dispatchResponseEvent method
				handleWom: {
					success: {
						widget: '@this',
						event: 'ready',
						callback: 'success'
					},
					failure: {
						widget: '@this',
						event: 'failure',
						callback: 'failure'
					}
				}
			});

			this.lastResponse = null;
			this.callParent('configure', arguments);
		},

		getApi: function () {
			return this;
		},

		success: function() {},
		failure: function() {},

		init: function() {
			var
				isc,
				ise = this.getOption('inboxSocketEvent')
			;

			this._transport = null;
			this.progress = 0;

			this._chunksCount = 0;
			this._chunksSent = 0;
			this._activeChunk = 0;
			this.getOption('autoLoad') && this.send(this.getOption('autoLoadParams') || {});

			if (ise) {
				if (fox.isString(this.getOption('inboxSocketCallback'))) {
					isc = fox.oop.getRealCallback(fox.oop.createCallback(this.getOption('inboxSocketCallback'), this));
				} else if (fox.isFunction(this.getOption('inboxSocketCallback'))) {
					isc = this.getOption('inboxSocketCallback');
				}

				this.handleEvent('@root #socket', ise, isc || this.dispatchResponseEvent, this.getOption('inboxEventParams') || {});
			}
		},

		_sendXFormData: function(data) {
			var
				files = data.listFiles(),
				loadEnd;

			loadEnd = function () {
				this.unsetUnloadMessage();
				this.inProgress = false;
				this.dispatchEvent('loadend');
			};

			if (!files) {
				var fd = new FormData;
				fox.each(data, function(val, name) {
					fd.append(name, val);
				});
				return this._sendFormData(fd);
			}

			var file = files['file'], // temporary, should be rewritten when you, yes YOU, will have time and inspiration
				func = (file.slice ? 'slice' : (file.mozSlice ? 'mozSlice' : (file.webkitSlice ? 'webkitSlice' : 'slice'))),
				fileSize = file.size,
				chunkSize = data.getFileChunkSize(),
				startByte = this._activeChunk * chunkSize,
				endByte = Math.min(fileSize, (this._activeChunk + 1) * chunkSize),
				realChunkSize = endByte - startByte
			;

			this._chunksCount = Math.ceil(fileSize / chunkSize);

			var isLastChunk = this._activeChunk >= this._chunksCount - 1,
				fileId = file.size + '-' + (file.webkitRelativePath || file.fileName || file.name).replace(/[^0-9a-zA-Z_-]/img, '')
			;

			var events = ['loadstart', 'progress', 'abort', 'error', 'timeout', 'loadend'];
			var xhr = this.__getXhr();

			xhr.onreadystatechange = fox.bind(function () {
				if (xhr.readyState == 4) {
					if (xhr.status == 200) {
						if (isLastChunk) {
							this._transport = xhr;
							this._onComplete.apply(this, arguments);
						} else {
							this._activeChunk++;
							return this._sendXFormData(data);
						}
					} else {
						xhr.__foxSend();
					}
				}
			}, this);

			fox.each(events, function(event) {
				fox.dom.on(event, xhr.upload, fox.bind(function(e) {
					switch (event) {
						case 'loadstart':
							if (!this._isNewRequest) {
								break;
							}

							this._isNewRequest = false;
							this.inProgress = true;
							this.progress = 0;
							this.setUnloadMessage();
							this.dispatchEvent(event);
						break;

						case 'progress':
							var loaded = (this._activeChunk * chunkSize + e.loaded),
								current = Math.floor(loaded / fileSize * 100)
							;

							if (this.progress < current) {
								this.progress = current;
								this.dispatchEvent(event, {percent: this.progress, loaded: loaded, total: fileSize});
							}
						break;

						case 'loadend':
							if (!isLastChunk) {
								break;
							}

							loadEnd.call(this);
						break;
					}
				}, this));
			}, this);

			var startUpload = fox.bind(function() {
				var fd = new FormData;
				fox.each(data.listValues(), function(val, key) {
					fd.append(key, val);
				});
				fd.append('__method', this.requireOption('method'));
				fd.append('_method', 'resumableUpload.postChunk');
				fd.append('_fileId', fileId);
				fd.append('_fileName', file.fileName || file.name);
				fd.append('_fileSize', fileSize);
				fd.append('_chunkSize', chunkSize);
				fd.append('_activeChunk', this._activeChunk + 1);
				fd.append('_chunksCount', this._chunksCount);
				fd.append('_isLastChunk', isLastChunk ? '1' : '0');
				fd.append('file', file[func](startByte, endByte));
				xhr.__foxSend = function() {
					xhr.open('POST', '/api.php', true);
					xhr.send(fd);
				};
				xhr.__foxSend();
			}, this);

			if (this._xParts.length) {
				while (this._xParts.indexOf(this._activeChunk + 1) != -1) {
					this._activeChunk++;
				}
			}

			var
				cfd = new FormData,
				cxhr = this.__getXhr()
			;
			cfd.append('_method', 'resumableUpload.checkChunk');
			cfd.append('_fileId', fileId);
			cfd.append('_fileName', file.fileName || file.name);
			cfd.append('_fileSize', fileSize);
			cfd.append('_chunkSize', chunkSize);
			cfd.append('_chunksCount', this._chunksCount);
			cfd.append('_activeChunk', this._activeChunk + 1);
			this.inProgress = true;

			cxhr.onreadystatechange = fox.bind(function() {
				if (cxhr.readyState == 4) {
					if (cxhr.status == 200) {
						var response = JSON.parse(cxhr.responseText);

						if (response && response.status) {
							if (response.response.parts) {
								this._xParts = response.response.parts;
							}

							if (response.response.exists) {
								var loaded = (this._activeChunk * chunkSize + realChunkSize);
								this.dispatchEvent('progress', {percent: Math.floor(loaded / fileSize * 100), loaded: chunkSize, total: fileSize});

								if (this._activeChunk < this._chunksCount) {
									this._activeChunk++;

									return this._sendXFormData(data);
								}

								loadEnd.call(this);
							}

							startUpload();
						}
					} else {
						cxhr.__foxSend();
					}
				}
			}, this);

			cxhr.__foxSend = function() {
				cxhr.open('POST', '/api.php', true);
				cxhr.send(cfd);
			};
			cxhr.__foxSend();
		},

		_sendFormData: function(data) {
			var params;

			if (data instanceof XFormData) {
				this._xParts = [];
				return this._sendXFormData(data);
			}

			if (data instanceof FormData) {
				params = data;
			} else if (fox.isArray(data)) {
				params = new FormData();

				fox.each(data, function (val) {
					if (typeof val[2] !== 'undefined') {
						params.append(val[0], val[1], val[2]);
					} else {
						params.append(val[0], val[1]);
					}
				});
			} else {
				params = new FormData();

				fox.each(data, function(val, name) {
					params.append(name, val);
				});
			}

			if (this.requireOption('sendTimezone')) {
				params.append('tz', this.getTimezone());
			}

			params.append('_method', this.requireOption('method'));

			var address = this.requireOption('address');

			if (this.getOption('domain') && address.indexOf('http') !== 0) {
				address = this.getOption('domain') + address;
			}

			var t = this.openConnection(address);

			t.setRequestHeader('Access-Control-Allow-Credentials', 'true');

			t.send(params);

			this._isNewRequest = false;
		},

		_send: function(data) {
			this._isNewRequest = true;

			if (this.getOption('useFormData')) {
				return this._sendFormData(data);
			}

			var t = this._getTransport();
			var postBody,
				address = this.requireOption('address'),
				params = {
					'_method': this.requireOption('method')
				};

			fox.site.activeApiPosts = 1 + (fox.site.activeApiPosts || 0);
			this.setUnloadMessage();

			t.send(params);
		}

	}, methods), 'Controller');

	var Api = function(options, wom) {
		if (!options) {
			options = {};
		}

		this._objClass = 'Api';
		this.isService = true;
		this.lastResponse = null;

		if (wom) {
			this.setWom(wom);
		}

		this.__constructor(options);
		if (fox.isEmpty(options.withoutEmbed)) {
			fox.site._embedWidget('api_' + this._id, this, {});
		}
		this._prepare();
	};

	Api.sentStack = 0;

	fox.registerService('Api', fox.extend(methods, fox.BaseObject, Api, 'Api'));
	fox.callApi = function(method, params, successCb, failureCb, wom) {
		if (!wom) {
			wom = fox.wom;
		}
		var options = {};
		if (fox.isObject(method)) {
			options = method.options || {};
			method = method.method;
		}

		var api =  new fox.Api(options, wom);
		api.method(method);
		options.domain && api.domain(options.domain);
		api.setOption('paramsToPath', options.paramsToPath);
		if (successCb) {
			wom.getEventManager().handle(api, options.simple ? 'success' : 'ready', function(res) {
				if (fox.isArray(successCb)) {
					fox.bind(successCb[0][successCb[1]], successCb[0])(res, successCb[2]);
				} else {
					successCb(res);
				}
			});
		}

		if (failureCb) {
			wom.getEventManager().handle(api, 'failure', function (res) {
				if (fox.isArray(failureCb)) {
					fox.bind(failureCb[0][failureCb[1]], failureCb[0])(res, failureCb[2]);
				} else {
					failureCb(res);
				}
			});
		}

		api.send(params, false);
		return api;
	},

	fox.requestApi = function(url, data) {
		return new fox.RSVP.Promise(function(resolve, reject) {
			var api =  new fox.Api({withoutEmbed:1}, fox.wom);
			postData = fox.toQueryString(data);
			if (api.getOption('httpMethod').toLowerCase() == 'get' && postData) {
				url += '?' + postData;
			}

			var xhr = api.openConnection(url);
			xhr.onload = function () {
				if (this.status >= 200 && this.status < 300) {
					resolve(xhr.response);
				} else {
					reject({
						status: this.status,
						statusText: xhr.statusText
					});
				}
			};
			xhr.onerror = function () {
				reject({
					status: this.status,
					statusText: xhr.statusText
				});
			};
			xhr.send(postData);
		});
	}
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/data/api.js
// module id = 106
// module chunks = 0